// Newsletter popup (snippets/cozy-newsletter-popup.liquid). No libraries.
// Opens on whichever comes first (owner, 2026-10-18): 3 s after load AND the cookie choice, or a scroll of >= 25% of
// the page (that one also waits for the cookie choice). Phones (max-width 699px, this popup's own breakpoint): a
// non-modal bottom sheet (dialog.show(), no backdrop, page stays scrollable/clickable, max 35% of the screen, no image);
// desktop: the modal dialog as before. Phones (v4): the sheet opens collapsed (title + qualifier + "קבלו 10%", ~20% of
// the screen); the button or the title expands it to the full form (up to 85% of the screen), focus on the email field.
// A return from our own post (success / Shopify's errors) opens expanded. At most once per visit (sessionStorage 'cozy-popup-shown'). Only when:
//   - the page is not the cart, checkout, a policy, contact, cancel or bot-check page (also checked in Liquid);
//   - the visitor has not signed up here and has not closed it in the last 14 days (localStorage 'cozy-popup');
//   - the cookie banner is not waiting for a choice (Customer Privacy API): if it is, after the choice;
//   - no other window is open (cart drawer, menu, search, size guide: any <dialog open>; the accessibility menu);
//     otherwise it waits until they close;
//   - the cart is empty (/cart.js); never once add-to-cart happens in this page view;
//   - on product pages (the kit too): never once the visitor has touched a variant / option picker;
//   - (short pages that cannot scroll show through the 3 s path);
//   - the session did not arrive from paid social (utm_source facebook/fb/ig/instagram/meta/tiktok, fbclid, ttclid):
//     sessionStorage 'poofiz_paid_session'.
// Sign-up: Shopify's customer form (contact[email] + tags), only with a valid email AND the consent box ticked.
// It is posted the way Shopify's own forms are: a normal full-page post, never fetch (Shopify's /contact answered a
// fetch from the hCaptcha-protected form with 400 on desktop, 2026-10-11). Shopify's spam protection
// (storefront-forms-hcaptcha) binds an invisible hCaptcha to the form and its own submit listener. Ours runs first
// (capture) and stops it, so there is one post, prepared the same way Shopify's listener does it: a fresh token from
// that same hCaptcha widget in h-captcha-response, and form_key (the form saved in sessionStorage, which Shopify's
// bot-check page /challenge uses to send it again). While hCaptcha may show a challenge (it opens outside the
// dialog), the dialog is non-modal so the challenge is on top and usable; then modal again.
// return_to = this page + pz_popup=1: Shopify brings the visitor back here (directly or after /challenge) and the
// popup opens straight in the success state; with Shopify's form errors it opens with the error instead.
// Success: the code (from a <template>) with a copy button, the kit link; the visitor is remembered.
(() => {
  const dialog = document.getElementById('CozyPopup');
  if (!dialog || (window.Shopify && window.Shopify.designMode)) return;

  // Paid social (owner, 2026-10-18): never for Facebook / Instagram / Meta / TikTok ad traffic, for the whole session.
  // utm_source with a whole token facebook|fb|ig|instagram|meta|tiktok (any case), or an fbclid / ttclid parameter, sets
  // sessionStorage poofiz_paid_session=1; with that flag the popup never opens (checked below, before any trigger).
  // Storage blocked or failing: only this address decides; otherwise normal behaviour.
  let paid = false;
  try {
    new URLSearchParams(location.search).forEach((v, k) => {
      k = k.toLowerCase();
      if (k === 'fbclid' || k === 'ttclid' || (k === 'utm_source' && /(^|[^a-z])(facebook|fb|ig|instagram|meta|tiktok)([^a-z]|$)/i.test(v))) paid = true;
    });
    if (paid) sessionStorage.setItem('poofiz_paid_session', '1');
    else paid = sessionStorage.getItem('poofiz_paid_session') === '1';
  } catch (e) { /* sessionStorage unavailable */ }

  const STORE = 'cozy-popup';
  const SNOOZE = 14 * 24 * 60 * 60 * 1000;
  const FLAG = 'pz_popup';
  const BLOCKED = /^\/(cart(\/|$)|checkouts?(\/|$)|challenge(\/|$)|policies\/|pages\/(contact|cancel-order)\/?$)/i;
  const read = () => {
    try { return JSON.parse(localStorage.getItem(STORE)) || {}; } catch (e) { return {}; }
  };
  const write = (value) => {
    try { localStorage.setItem(STORE, JSON.stringify(value)); } catch (e) { /* private mode: the popup may come back */ }
  };
  const snoozed = () => {
    const seen = read();
    return !!(seen.subscribed || (seen.closedAt && Date.now() - seen.closedAt < SNOOZE));
  };

  const loaded = new Promise((resolve) => {
    if (document.readyState === 'complete') resolve();
    else window.addEventListener('load', resolve, { once: true });
  });

  // The stylesheet is fetched only when the popup is about to show, so nothing about it blocks the first render.
  const loadCss = () => new Promise((resolve) => {
    const href = dialog.dataset.css;
    if (!href || document.querySelector(`link[href="${href}"]`)) return resolve();
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });

  // ---------- Elements ----------
  const form = dialog.querySelector('[data-popup-form]');
  const email = form.querySelector('#CozyPopupEmail');
  const consent = form.querySelector('#CozyPopupConsent');
  const emailError = form.querySelector('#CozyPopupEmailError');
  const consentError = form.querySelector('#CozyPopupConsentError');
  const sendError = form.querySelector('#CozyPopupSendError');
  const submit = form.querySelector('[data-popup-submit]');
  const offer = dialog.querySelector('[data-popup-offer]');
  const done = dialog.querySelector('[data-popup-done]');
  const doneText = dialog.querySelector('[data-popup-done-text]');
  const codeSlot = dialog.querySelector('[data-popup-code]');
  const codeTemplate = dialog.querySelector('[data-popup-code-template]');
  const copyButton = dialog.querySelector('[data-popup-copy]');
  const copied = dialog.querySelector('[data-popup-copied]');
  const kitLink = dialog.querySelector('[data-popup-kit]');
  const EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;

  let returnFocus = null;
  // The photo (2026-10-19, LCP): Chrome counts an <img> (and a CSS background image) that paints when the popup opens
  // as the page's Largest Contentful Paint (desktop kit page: the popup photo at ~4.2 s). A <canvas> is never an LCP
  // candidate, so the photo is drawn into one: the same file the <img> would pick (same srcset + sizes on a detached
  // Image), drawn 1:1 at its own pixel size, and the canvas keeps the <img>'s box and object-fit / object-position
  // (assets/cozy-popup.css), so size, crop and sharpness are the same. The canvas has role="img" + the alt text.
  // Pre-warm: desktop only (on phones the sheet has no photo), after load + the cart check and a little before the
  // earliest opening; it fetches and decodes the file without painting it, so the photo is there the moment the
  // popup opens. If the canvas cannot be used, the <img> loads as before.
  const photoSource = () => dialog.querySelector('.cozy-pop__media img[data-src]');
  let photo = null;
  const warmPhoto = () => {
    if (photo) return photo;
    const source = photoSource();
    if (!source) return null;
    const pic = new Image();
    pic.decoding = 'async';
    const sizes = source.getAttribute('sizes');
    if (sizes) pic.sizes = sizes;
    if (source.dataset.srcset) pic.srcset = source.dataset.srcset;
    pic.src = source.dataset.src;
    const loadOf = (im) => new Promise((resolve) => {
      if (im.complete && im.naturalWidth) return resolve(true);
      im.addEventListener('load', () => resolve(true), { once: true });
      im.addEventListener('error', () => resolve(false), { once: true });
    });
    // An image picked from a srcset reports its size divided by its density (380w for a 300px slot reads as 300px
    // wide), so the picked file (currentSrc, already in the browser cache) is opened once more on its own to be drawn
    // at its real pixel size.
    photo = { pic: null, ready: loadOf(pic).then((ok) => {
      if (!ok) return false;
      const file = new Image();
      file.decoding = 'async';
      file.src = pic.currentSrc || pic.src;
      return loadOf(file).then((done) => {
        if (!done) return false;
        photo.pic = file;
        return file.decode ? file.decode().then(() => true, () => true) : true;
      });
    }) };
    return photo;
  };
  const imgFallback = (img) => {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  };
  const showImage = () => {
    const img = photoSource();
    // The image only when it will show (on phones it can be switched off: Theme settings).
    if (!img || getComputedStyle(img.parentElement).display === 'none') return;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx) return imgFallback(img);
    const warm = warmPhoto();
    canvas.className = 'cozy-pop__photo';
    canvas.setAttribute('role', 'img');
    canvas.setAttribute('aria-label', img.alt || '');
    canvas.width = Number(img.getAttribute('width')) || 760;
    canvas.height = Number(img.getAttribute('height')) || 950;
    const paint = () => {
      const pic = warm.pic;
      canvas.width = pic.naturalWidth;
      canvas.height = pic.naturalHeight;
      ctx.drawImage(pic, 0, 0);
    };
    img.replaceWith(canvas);
    // Pre-warmed (the usual case): drawn now, before the popup is shown, so there is no empty frame.
    if (warm.pic && warm.pic.complete && warm.pic.naturalWidth) paint();
    else warm.ready.then((ok) => { if (ok && warm.pic) paint(); else { canvas.replaceWith(img); imgFallback(img); } });
  };

  // Phones: a non-modal bottom sheet (assets/cozy-popup.css .is-sheet): no backdrop, the page behind stays usable.
  // The class goes on before show(), so the slide-up starts from below and the image (hidden in the sheet) never loads.
  const SHEET = '(max-width: 699px)';
  const isSheet = () => dialog.classList.contains('is-sheet');
  // Collapsed sheet (v4): only a teaser, built here on first use (phones only; the snippet is unchanged): the qualifier,
  // taken verbatim from the approved body text (shown only while that text still contains it, so 10% never shows
  // without its condition), and the "קבלו 10%" button (aria-expanded, controls the form).
  const QUALIFIER = '10% הנחה על ההזמנה הראשונה מ-₪300';
  let teaser = null;
  let expandButton = null;
  const bdi = (text) => {
    const el = document.createElement('bdi');
    el.textContent = text;
    return el;
  };
  const buildTeaser = () => {
    if (teaser) return;
    const bodyText = dialog.querySelector('.cozy-pop__text');
    const head = dialog.querySelector('.cozy-pop__head');
    if (!head || !offer) return;
    if (!offer.id) offer.id = 'CozyPopupOffer';
    teaser = document.createElement('div');
    teaser.className = 'cozy-pop__teaser';
    teaser.hidden = true;
    if (bodyText && bodyText.textContent.replace(/\s+/g, ' ').includes(QUALIFIER)) {
      const qualifier = document.createElement('p');
      qualifier.className = 'cozy-pop__qualifier';
      qualifier.append(bdi('10%'), ' הנחה על ההזמנה הראשונה מ-', bdi('₪300'));
      teaser.append(qualifier);
    }
    expandButton = document.createElement('button');
    expandButton.type = 'button';
    expandButton.className = 'cozy-btn cozy-btn--cta cozy-pop__expand';
    expandButton.setAttribute('aria-expanded', 'false');
    expandButton.setAttribute('aria-controls', offer.id);
    expandButton.append('קבלו ', bdi('10%'));
    expandButton.addEventListener('click', () => expand());
    teaser.append(expandButton);
    head.after(teaser);
  };
  const setCollapsed = (on) => {
    dialog.classList.toggle('is-collapsed', on);
    if (teaser) teaser.hidden = !on;
    if (expandButton) expandButton.setAttribute('aria-expanded', on ? 'false' : 'true');
  };
  const present = (collapsed = false) => {
    const sheet = !!(window.matchMedia && window.matchMedia(SHEET).matches);
    dialog.classList.toggle('is-sheet', sheet);
    if (sheet && collapsed) buildTeaser();
    setCollapsed(sheet && collapsed && !!teaser);
    showImage();
    returnFocus = document.activeElement;
    if (sheet) dialog.show();
    else dialog.showModal();
  };
  // Expand: the sheet grows from its collapsed height (max-height on the fixed sheet only: no page layout moves).
  const expand = () => {
    if (!dialog.open || !dialog.classList.contains('is-collapsed')) return;
    const from = dialog.getBoundingClientRect().height;
    dialog.style.transition = 'none';
    dialog.style.maxHeight = `${from}px`;
    void dialog.offsetHeight;
    dialog.style.transition = '';
    setCollapsed(false);
    dialog.style.maxHeight = '';
    email.focus();
  };
  dialog.querySelector('#CozyPopupTitle').addEventListener('click', expand);

  // At most once per visit: an opened popup (closed or just ignored, e.g. the sheet left open while browsing) does
  // not open again in this tab's session. Closing it also snoozes it for 14 days (below).
  const VISIT = 'cozy-popup-shown';
  const shownThisVisit = () => {
    try { return sessionStorage.getItem(VISIT) === '1'; } catch (e) { return false; }
  };

  // Success: remember the sign-up, put the code into the page (only now, from the <template>), show the success state.
  const succeed = () => {
    write({ subscribed: true });
    const code = codeTemplate ? codeTemplate.content.textContent.trim() : '';
    if (code) codeSlot.textContent = code;
    else dialog.querySelectorAll('[data-popup-code-row]').forEach((el) => { el.hidden = true; });
    offer.hidden = true;
    done.hidden = false;
    (code ? doneText : kitLink).focus();
  };

  // Back from the post. Only this tab's own post can show the code: a sessionStorage mark written just before
  // posting (kept 30 min). With the mark, Shopify's answer counts when the page carries it: pz_popup=1 (our
  // return_to; Shopify's bot check /challenge sends the saved form, return_to included, after it is passed),
  // customer_posted=true, or Shopify's posted marker. Shopify's form errors: the popup opens with the error, ready
  // to send again. Without the mark (a shared link, a reload after success, another tab) the code never shows.
  // Our marks are dropped from the address so a reload does not repeat anything.
  const SENT = 'cozy-popup-sent';
  const session = () => {
    try { return window.sessionStorage; } catch (e) { return null; }
  };
  const params = new URLSearchParams(location.search);
  const store = session();
  let sentAt = 0;
  try { sentAt = Number(store && store.getItem(SENT)) || 0; } catch (e) { /* storage blocked: no mark */ }
  const pending = sentAt > 0 && Date.now() - sentAt < 30 * 60 * 1000;
  const forget = () => {
    try { if (store) store.removeItem(SENT); } catch (e) { /* nothing to forget */ }
  };
  if (sentAt && !pending) forget();
  // Shopify adds the posting form's anchor: an answer for another customer form (the footer newsletter,
  // #ContactFooter) is that form's, not ours. pz_popup=1 is only ever our return_to.
  const anchor = location.hash.length > 1 ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
  const ours = !(anchor && anchor.tagName === 'FORM' && anchor !== form);
  const errors = pending && ours && !!form.querySelector('[data-popup-form-errors]');
  const posted = pending && !errors && (params.get(FLAG) === '1'
    || (ours && (params.get('customer_posted') === 'true' || !!form.querySelector('[data-popup-posted]'))));
  if (params.get(FLAG) === '1' || location.hash === '#CozyPopupForm' || posted || errors) {
    params.delete(FLAG);
    params.delete('customer_posted');
    const rest = params.toString();
    history.replaceState(history.state, '', location.pathname + (rest ? `?${rest}` : '') + location.hash.replace(/^#CozyPopupForm$/, ''));
  }
  if (posted || errors) {
    forget();
    loaded.then(loadCss).then(() => {
      present();
      if (posted) return succeed();
      sendError.textContent = form.dataset.errorNetwork || '';
      email.focus();
    });
  }

  if (BLOCKED.test(location.pathname)) return;
  // Paid-social session (see top): no consent wait, scroll listener or cart check; only our own post's return shows.
  if (paid && !(posted || errors)) return;

  // ---------- Opening ----------
  // Cookie banner first: while Shopify still has to ask (banner due AND no choice made yet), wait for the visitor's
  // choice (no delay after). shouldShowBanner() stays true after the choice, so the choice itself is checked too.
  const consentDone = new Promise((resolve) => {
    const decide = () => {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      const due = !!privacy && typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner();
      let undecided = true;
      if (due && typeof privacy.getTrackingConsent === 'function') {
        undecided = privacy.getTrackingConsent() === 'no_interaction';
      } else if (due && typeof privacy.currentVisitorConsent === 'function') {
        const choice = privacy.currentVisitorConsent() || {};
        undecided = ['marketing', 'analytics', 'preferences'].every((k) => !choice[k]);
      }
      const pending = due && undecided;
      if (!pending) return resolve();
      document.addEventListener('visitorConsentCollected', () => resolve(), { once: true });
    };
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => (error ? resolve() : decide()));
    } else {
      resolve();
    }
  });

  // Never on top of another window, the cookie banner or its preferences, and never while the visitor is typing in
  // a field on the page: check once a second until the page is free. (Fixed elements have no offsetParent, so
  // "shown" is the computed display/visibility plus a box on screen, for the element or its first child.)
  const shown = (el) => !!el && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden'
    && (el.getClientRects().length > 0 || (!!el.firstElementChild && el.firstElementChild.getClientRects().length > 0));
  const TYPING = 'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable]:not([contenteditable="false"])';
  const busy = () => {
    if (document.querySelector('dialog[open]')) return true;
    if (document.documentElement.classList.contains('cozy-a11y-open')) return true;
    if (['shopify-pc__banner', 'shopify-pc__prefs'].some((id) => shown(document.getElementById(id)))) return true;
    const active = document.activeElement;
    return !!active && !dialog.contains(active) && active.matches(TYPING);
  };
  const whenFree = () => new Promise((resolve) => {
    const check = () => (busy() || document.visibilityState !== 'visible' ? setTimeout(check, 1000) : resolve());
    check();
  });

  const open = async () => {
    // Signed up or closed meanwhile (e.g. in another tab): stay closed, fetch nothing.
    if (snoozed() || shownThisVisit() || dialog.open || blocked()) return;
    await loadCss();
    if (busy()) await whenFree();
    await refreshCart();
    if (snoozed() || shownThisVisit() || dialog.open || blocked()) return;
    try { sessionStorage.setItem(VISIT, '1'); } catch (e) { /* storage blocked: the 14-day snooze still applies */ }
    present(true);
    // Focus lands on the title (read first, no keyboard pops up on phones); Tab goes on to the close button and the form.
    dialog.querySelector('#CozyPopupTitle').focus();
  };

  // ---------- Time / scroll + cart gate (owner, 2026-10-16; trigger 2026-10-18) ----------
  // All pages: 3 s after load + the cookie choice, or after scrolling a quarter of the page, whichever comes first. Never with items in the cart (check
  // /cart.js before showing; cancel if add-to-cart happens in this page view). On product pages (the kit too):
  // also never once the visitor has touched a variant / option picker. Short pages show through the 3 s path.
  const pageType = window.ShopifyAnalytics?.meta?.page?.pageType;
  const isProduct = pageType === 'product' || (!pageType && /\/products\/[^/]+\/?$/.test(location.pathname)
    && !!document.querySelector('form[action*="/cart/add"]'));
  let engaged = false;
  let cartHasItems = false;
  let addedToCart = false;
  const PICKERS = '[data-variant-picker], [data-option-fieldset], [data-kb-style], [data-kb-options], variant-selects, variant-radios, [name^="options["], form[action*="/cart/add"]';
  const ADDS = 'form[action*="/cart/add"] [type="submit"], button[name="add"], [data-kb-add], [data-add-to-cart]';
  const onInteract = (e) => {
    const t = e.target;
    if (!t || !t.closest || dialog.contains(t)) return;
    const isAdd = e.type === 'submit' ? t.matches('form[action*="/cart/add"]') : !!t.closest(ADDS);
    if (isAdd) {
      addedToCart = true;
      // The sheet left open while shopping: it goes away on add to cart (not a close: no snooze, no focus move).
      if (dialog.open && isSheet()) { quiet += 1; dialog.close(); }
    }
    else if (isProduct && t.closest(PICKERS)) engaged = true;
  };
  ['change', 'input', 'click', 'submit'].forEach((type) => document.addEventListener(type, onInteract, true));
  const scrolledQuarter = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    return max > 0 && scrollY / max >= 0.25;
  };
  const scrolled = new Promise((resolve) => {
    if (scrolledQuarter()) return resolve();
    const onScroll = () => {
      if (!scrolledQuarter()) return;
      removeEventListener('scroll', onScroll);
      resolve();
    };
    addEventListener('scroll', onScroll, { passive: true });
  });
  const refreshCart = () => fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => { cartHasItems = (cart.item_count || 0) > 0; })
    .catch(() => {});
  const cartChecked = refreshCart();
  const blocked = () => cartHasItems || addedToCart || (isProduct && engaged);

  if (!snoozed() && !shownThisVisit()) {
    // The 3 s timer starts only once the page has loaded AND the cookie choice is made.
    const ready = Promise.all([loaded, consentDone]);
    const timed = ready.then(() => new Promise((resolve) => setTimeout(resolve, 3000)));
    // Desktop: fetch + decode the photo (not painted) once the page has loaded and the cart was checked, so it is
    // ready when the popup opens (the timer path opens 3 s later; the scroll path also waits for the CSS + /cart.js).
    Promise.all([loaded, cartChecked]).then(() => {
      if (blocked() || snoozed() || (window.matchMedia && window.matchMedia(SHEET).matches)) return;
      const warm = () => warmPhoto();
      if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 1000 });
      else setTimeout(warm, 200);
    });
    Promise.all([ready, Promise.race([timed, scrolled]), cartChecked])
      .then(() => { if (!blocked()) return whenFree().then(() => { if (!blocked()) open(); }); });
  }

  // ---------- Closing ----------
  // Closing (X, Esc, backdrop): snooze 14 days unless signed up; focus goes back where it was.
  // A modal swap (swapModal) closes and reopens the dialog: its close event (one per swap, queued) is not a close.
  let quiet = 0;
  dialog.addEventListener('close', () => {
    if (quiet > 0) { quiet -= 1; return; }
    if (dialog.open) return;
    if (!read().subscribed) write({ closedAt: Date.now() });
    if (returnFocus && document.contains(returnFocus) && typeof returnFocus.focus === 'function') returnFocus.focus();
  });
  dialog.querySelector('[data-popup-close]').addEventListener('click', () => dialog.close());
  // Audit fix 2026-10-24: the phone sheet also closes on a tap outside it (while collapsed, or before an email is typed,
  // so a half-filled sign-up or the hCaptcha challenge never loses it) and on Esc anywhere on the page.
  let outsideDown = false;
  document.addEventListener('pointerdown', (event) => {
    outsideDown = dialog.open && isSheet() && !dialog.contains(event.target);
  }, true);
  document.addEventListener('click', (event) => {
    const was = outsideDown;
    outsideDown = false;
    if (!was || !dialog.open || !isSheet() || dialog.contains(event.target)) return;
    if (!dialog.classList.contains('is-collapsed') && email && email.value.trim()) return;
    dialog.close();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dialog.open && isSheet() && !dialog.contains(event.target)) dialog.close();
  });
  // Desktop (modal): Tab stays inside: from the last control back to the first, and Shift+Tab the other way (a native modal dialog
  // would otherwise let focus out to the page / browser bar).
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isSheet()) {
      event.preventDefault();
      dialog.close();
      return;
    }
    // The sheet is non-modal (the page stays usable), so focus is not trapped in it.
    if (event.key !== 'Tab' || isSheet()) return;
    const items = [...dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((el) => !el.disabled && el.getClientRects().length > 0 && !el.closest('[hidden]'));
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    const inside = items.includes(document.activeElement);
    if (event.shiftKey && (document.activeElement === first || !inside)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !inside)) {
      event.preventDefault();
      first.focus();
    }
  });
  // The dialog box has no padding of its own, so a click whose target is the <dialog> itself is on the backdrop. Only
  // a click that also started there closes it: selecting text in the field and releasing the mouse outside must not
  // (and the theme's shared backdrop handler, assets/cozy-header.js, must not see that click either).
  let downOnBackdrop = false;
  let upOnBackdrop = false;
  dialog.addEventListener('pointerdown', (event) => { downOnBackdrop = event.target === dialog; });
  dialog.addEventListener('pointerup', (event) => { upOnBackdrop = event.target === dialog; });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    // A keyboard-made click has no pointer events: only the real press-and-release outside the panel closes it.
    if (downOnBackdrop && upOnBackdrop) dialog.close();
    else event.stopPropagation();
    downOnBackdrop = false;
    upOnBackdrop = false;
  });

  // ---------- Success state ----------
  // The kit link: close the popup (the sign-up is already remembered) and follow the link.
  if (kitLink) kitLink.addEventListener('click', () => { if (dialog.open) dialog.close(); });
  // Copy the code; the confirmation is announced (aria-live), and announced again on a second copy.
  const say = (text) => {
    copied.textContent = '';
    setTimeout(() => { copied.textContent = text; }, 60);
  };
  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const code = codeSlot.textContent.trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        // Older browsers / no clipboard permission: select the code and use the legacy copy command.
        const range = document.createRange();
        range.selectNodeContents(codeSlot);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        try { document.execCommand('copy'); } catch (e) { /* the code stays selected for a manual copy */ }
      }
      say(copied.dataset.copiedText || '');
    });
  }

  // ---------- Form ----------
  const setError = (field, box, text) => {
    box.textContent = text || '';
    if (field) field.setAttribute('aria-invalid', text ? 'true' : 'false');
  };
  email.addEventListener('input', () => { if (email.getAttribute('aria-invalid') === 'true' && EMAIL.test(email.value.trim())) setError(email, emailError, ''); });
  consent.addEventListener('change', () => { if (consent.checked) setError(consent, consentError, ''); });

  // hCaptcha token from the widget Shopify rendered in this form (none when its spam protection is off or not loaded).
  // The widget is reset first, so every attempt gets a fresh token (an earlier one may have expired or been used).
  // Meanwhile the dialog is non-modal (.is-captcha): a challenge hCaptcha opens outside it stays on top and usable,
  // and there is no time limit while the visitor solves it. Closing the challenge (or letting it expire) is not an
  // error: { cancelled: true }, the form stays as typed and can be sent again.
  const swapModal = (modal) => {
    if (!dialog.open || isSheet() || dialog.matches(':modal') === modal) return;
    quiet += 1;
    dialog.close();
    if (modal) dialog.showModal();
    else dialog.show();
    dialog.classList.toggle('is-captcha', !modal);
  };
  const CANCELLED = /challenge[-_ ]?(closed|expired)|expired|closed/i;
  const captchaToken = async () => {
    const widget = form.querySelector('[data-hcaptcha-widget-id]');
    const api = window.hcaptcha;
    if (!widget || !api || typeof api.execute !== 'function') return { token: null };
    const id = widget.getAttribute('data-hcaptcha-widget-id');
    try { if (typeof api.reset === 'function') api.reset(id); } catch (e) { /* not rendered yet: execute renders it */ }
    swapModal(false);
    try {
      const result = await api.execute(id, { async: true });
      return { token: (result && result.response) || null };
    } catch (error) {
      if (CANCELLED.test(String((error && error.message) || error))) return { cancelled: true };
      throw error;
    } finally {
      // Modal again (showModal moves focus to the title): back to the button the visitor pressed.
      swapModal(true);
      submit.focus();
    }
  };

  // The post, prepared like Shopify's own hCaptcha listener (storefront-forms-hcaptcha) prepares it, then sent as a
  // normal full-page post (the prototype's submit: no submit event, and not Shopify's replacement form.submit, which
  // would ask hCaptcha again). Comes back here with pz_popup=1 (return_to) to show the success state.
  const hidden = (name) => {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    return input;
  };
  const NOT_SAVED = ['recaptcha-v3-token', 'g-recaptcha-response', 'h-captcha-response', 'password'];
  const post = (token) => {
    // Back to this page; on a page Shopify rendered at the form's own address (/contact), back to the home page.
    const onAction = location.pathname === new URL(form.action, location.href).pathname;
    const back = new URLSearchParams(onAction ? '' : location.search);
    back.set(FLAG, '1');
    hidden('return_to').value = `${onAction ? '/' : location.pathname}?${back.toString()}`;
    // hCaptcha's own field in the widget (a textarea) and Shopify's hidden input: the same fresh token in each, or
    // emptied when there is none (an earlier token is already used).
    const fields = form.querySelectorAll('[name="h-captcha-response"]');
    if (token && !fields.length) hidden('h-captcha-response').value = token;
    fields.forEach((field) => { field.value = token || ''; });
    const store = session();
    if (store) {
      try {
        // form_key: Shopify's bot-check page sends the saved form again (everything but tokens and passwords).
        const previous = form.querySelector('input[name="form_key"]');
        if (previous && previous.value) store.removeItem(previous.value);
        const key = Array.from({ length: 32 }, () => Math.random().toString(36).slice(2, 3) || '0').join('');
        hidden('form_key').value = key;
        const data = {};
        for (const [name, value] of new FormData(form).entries()) if (!NOT_SAVED.includes(name)) data[name] = value;
        store.setItem(key, JSON.stringify({ __shopify_v: 1, action: form.action, data }));
        store.setItem(SENT, String(Date.now()));
      } catch (e) { /* storage full or blocked: Shopify still takes the post itself */ }
    }
    HTMLFormElement.prototype.submit.call(form);
  };
  // Back to this page from the browser's back/forward cache after the post: the button is ready again.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    submit.removeAttribute('aria-disabled');
    submit.removeAttribute('aria-busy');
    submit.classList.remove('is-loading');
    sending = false;
  });

  let sending = false;
  // Capture: runs before Shopify's own submit listener, which is stopped (it would post the form a second time).
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (sending) return;
    setError(null, sendError, '');
    email.value = email.value.trim();
    const emailOk = EMAIL.test(email.value) && email.checkValidity();
    setError(email, emailError, emailOk ? '' : form.dataset.errorEmail);
    setError(consent, consentError, consent.checked ? '' : form.dataset.errorConsent);
    if (!emailOk) return email.focus();
    if (!consent.checked) return consent.focus();

    // Busy look without the disabled property: a disabled button loses keyboard focus (it would fall out of the dialog).
    sending = true;
    let leaving = false;
    submit.setAttribute('aria-disabled', 'true');
    submit.setAttribute('aria-busy', 'true');
    submit.classList.add('is-loading');
    try {
      let captcha;
      try {
        captcha = await captchaToken();
      } catch (error) {
        // hCaptcha itself failed (script, network): post without a token, Shopify then asks for its bot check.
        console.warn('Newsletter popup: no hCaptcha token', error);
        captcha = { token: null };
      }
      if (captcha.cancelled) return;
      leaving = true;
      post(captcha.token);
    } catch (error) {
      leaving = false;
      console.warn(error);
      setError(null, sendError, form.dataset.errorNetwork);
    } finally {
      if (!leaving) {
        submit.removeAttribute('aria-disabled');
        submit.removeAttribute('aria-busy');
        submit.classList.remove('is-loading');
        if (!dialog.contains(document.activeElement)) submit.focus();
        sending = false;
      }
    }
  }, true);
})();
